<div class="bl-padding-sm--24 bl-justify-content--center bl-text-align--center">
  <div class="bl-max-width--100 bl-margin-x--auto bl-margin-bottom--8">
    <ea-svg
      svgClass="contact-lender bl-margin-x--16 bl-margin-y--8"
      svgDescription="contact lender icon"
      minWidth="56px"
      minHeight="56px"
      width="80px"
      height="80px"
    >
    </ea-svg>
  </div>
  <h3 class="bl-font-color--steel bl-font-weight--900 bl-margin-bottom--16">{{ headingMessage }}</h3>
  @if (isUserAuthenticated) {
    <p class="bl-font-color--slate bl-margin-bottom--16">{{ migratedContactMessage }}</p>
  }
  <div
    class="bl-display--block bl-display-sm--flex bl-flex-direction--row-reverse bl-justify-content--center bl-width-sm--75 bl-margin-x--auto bl-margin-top--32"
  >
    <button
      type="button"
      id="navigate-button"
      (click)="onNavigationButtonClick()"
      class="bl-button bl-margin-bottom--16 bl-margin-bottom-sm--0"
    >
      {{ navigationButtonText }}
    </button>
  </div>
</div>
